import React, { useEffect } from 'react';
import {useQuery} from 'react-query';
import {Link, useNavigate} from "react-router-dom";
import { Swiper, SwiperSlide, autoplay } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import {getGlobalSettingValue, getItemOfSessionStorage} from "../../../services/common/utils";
import { SELECTED_LANG } from "../../../services/common/Constants";
import {redirecturl} from '../../../services/common/redirect';
import { useSelector } from 'react-redux';
import { getImgSrc, getMilliseconds } from '../../../services/common/CommonUtils';
function Promotions({pmsitem}) {
    const {
        utilityData: { globalSetting },
      } = useSelector((state) => state);

    const settingsArr = globalSetting
    ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
    : [];

   const {
        data :{data}={},
        isLoading,
        isFetching,
    } = useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid), {}, false], 
    {
        retry: false,
        retryOnMount: false,
        cacheTime: 0,
        staleTime: 0
    })
    const navigate = useNavigate();
    const handleRedirect = (url) =>{
        if(url?.indexOf("https://") === 0){
            window.open(url, "_blank");
        }else{
            redirecturl(url, navigate)
        }
    }

   if(isLoading || isFetching){
    return(
<section class="dls-sprint13-comp">
    <div class="flex_grp_between mb-3">
        <h3 class="section_title_light mb-0 shimmerBG shimmer-card-title w-50 p-3"></h3>
        <a class="hyperlink shimmerBG shimmer-p-text p-2 w-25 m-0">
        </a>
    </div>

    <div class="swiper-container dls13_promo_swiper1 mb-30">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="shimmerBG shimmer-img-lg bor border-radious15">
                    <a href="">
                    </a>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="shimmerBG shimmer-img-lg border-radious15">
                    <a href="">
                    </a>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="shimmerBG shimmer-img-lg border-radious15">
                    <a href="">
                    </a>
                </div>
            </div>
        </div>
        <div class="swiper-pagination pt-5"></div>
    </div>
</section>

    );
   }

   const seconds = getGlobalSettingValue('promotiontimer', settingsArr);
   const swiperDelay = getMilliseconds(seconds);

  return (
    <section class="dls-sprint13-comp">
        <div class="flex_grp_between">
            <h3 class="section_title_light mb-0">{pmsitem?.elementmeta?.title}</h3>
                <Link class="hyperlink" to="/promotionsviewall" state= {data?.response?.[0]?.name}>
                    {pmsitem?.elementmeta?.more_title}
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                </Link>
            </div>

            <div class="swiper-container dls13_promo_swiper1">
                {/* <div class="swiper-wrapper"> */}
                <Swiper
                    modules={[Pagination, Autoplay]}
                    className="swiper-wrapper"
                    slidesPerView={1}
                    pagination={{
                    clickable: true
                    }}
                    autoplay={{
                        delay: swiperDelay,
                        disableOnInteraction: false,
                                           }}  
                reverseDirection= {getItemOfSessionStorage(SELECTED_LANG) === "ar" ? true : false}                    
                    loop={true}
                >
                {data?.response?.[0]?.banners?.map(item => (
                   <SwiperSlide>
                   <div>
                    <Link onClick={()=> handleRedirect(item?.url)}>
                        <img width= "100%" 
                        className='border-radius15'
                        //src={item?.path}
                        src={getImgSrc(`${item?.path + '?tmp=' + 't' + Date.now()}`, true)}
                         alt="" title=""  ></img></Link>
                   </div>
               </SwiperSlide>
                ))}
            </Swiper>
                </div>
            {/* </div> */}
        </section>
  )
}

export default Promotions
